<template>
  <div class="footer-wrap">
    <span>(주) 서티라이프</span>
    <span>ㆍ</span>
    <a :href="url.privacyPolicy" target="_blank">개인정보 처리방침</a>
    <span>ㆍ</span>
    <a :href="url.termsOfUse" target="_blank">이용 약관</a>
  </div>
</template>
<script>
import {Constants} from "@/utils/constants";

export default {
  data( ){
    return {
      url: {
        privacyPolicy: Constants.policiesUrl.privacyPolicyUrl,
        termsOfUse: Constants.policiesUrl.termsOfUseUrl,
        contact: Constants.otherUrl.certiLifeUrlWithContact,
      },
    }
  }
}
</script>